import React from 'react';
import EmptyMessage from 'src/components/emptyMessage';

import styles from './notFound.module.scss';

interface CourseNotFoundProps {
  onBack: () => void;
}

export const CourseNotFound: React.FC<CourseNotFoundProps> = ({ onBack }) => {
  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <EmptyMessage
          width="auto"
          image={'/images/page_not_found.svg'}
          heading="Course not found!"
          message="The course does not exist."
        />
      </div>
    </div>
  );
};

interface SimulationNotFoundProps {
  onBack: () => void;
}
export const SimulationNotFound: React.FC<SimulationNotFoundProps> = ({ onBack }) => {

  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <EmptyMessage
          width="auto"
          image={'/images/page_not_found.svg'}
          heading="Simulation not found!"
          message="The simulation does not exist."
        />
      </div>
    </div>
  );
};

interface PodcastNotFoundProps {
  onBack: () => void;
}
export const PodcastNotFound: React.FC<PodcastNotFoundProps> = ({ onBack }) => {

  const handleBackClicked = () => {
    onBack();
  };

  return (
    <div className={styles.container}>
      <div className={styles.back} onClick={handleBackClicked}>
        <i className="paperflite-left-arrow"></i>
        <span>my courses</span>
      </div>
      <div className={styles.body}>
        <EmptyMessage
          width="auto"
          image={'/images/page_not_found.svg'}
          heading="Podcast not found!"
          message="The podcast does not exist."
        />
      </div>
    </div>
  );
};